module.exports = __webpack_public_path__ + "img/kankou_15.1a57b1b8.jpg";